export class StaticCalendarEntity {
  corpId: number;
  id: number;
  name: string;
  alias: string;
  courseId: number;
  startDate: string;
  endDate: string;
  showInCampus: boolean;
  showInMagnament: boolean;
}
